// import Calendar from "@/utils/calendar";

export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 40,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "(源)批次包",
    dataIndex: "pkgCode",
    key: "pkgCode",
  },
  {
    title: "(新)批次包",
    dataIndex: "pkgCodeNew",
    key: "pkgCodeNew",
  },
  {
    title: "入库单",
    dataIndex: "inboundCode",
    key: "inboundCode",
  },
  {
    title: "图片",
    dataIndex: "productImg",
    key: "productImg",
    scopedSlots: {
      customRender: "image",
    },
  },
  {
    title: "商品SKU",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "异常件数",
    dataIndex: "abnormalAmount",
    key: "abnormalAmount",
  },
  {
    title: "异常类型",
    dataIndex: "abnormalType",
    key: "abnormalType",
    customRender: (text, record) => {
      return text === 0?'少件':'多件';
    },
  },
  {
    title: "订单来源",
    dataIndex: "systemSource",
    key: "systemSource",
    customRender: (text,record) => {
        return {1:'D2C',2:'B2B'}[text]||'-'
    },
  },
  {
    title: "责任人",
    dataIndex: "createrName",
    key: "createrName",
    scopedSlots: {
      customRender: "createrName",
    },
  },
  {
    title: "操作",
    dataIndex: "idAction",
    width: 270,
    key: "idAction",
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const dataSource = [
  {
    warehouse: "1",
    regionName: "1",
    regionContact: "1",
    contactPhone: "1",
    address: "1",
    total: "1",
    result: "1",
    num: "1",
    type: "1",
    innerCode: "1",
    abnormalAmount: "1"
  },
];
